import { render } from "./GaqForm.vue?vue&type=template&id=6080c080&scoped=true"
import script from "./GaqForm.vue?vue&type=script&lang=js"
export * from "./GaqForm.vue?vue&type=script&lang=js"

import "./GaqForm.vue?vue&type=style&index=0&id=6080c080&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6080c080"]])

export default __exports__